/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { filterObj } from '@/utils/util';
import {
  postAction,
  getAction,
  deleteAction,
  downFile,
  uploadAction,
  getFileAccessHttpUrl,
} from '@/api/manage';
import Vue from 'vue';
import store from '@/store';
import { Notification, MessageBox, Message } from 'element-ui';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import {
  getPolicyBase64,
  getSignature,
  randomString,
  getSuffix,
} from '@/utils/util';
import { getToken, removeToken } from '@/utils/auth';

export const listMixin = {
  data() {
    return {
      deleteKey: 'id',

      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      /* 数据源 */
      dataSource: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      /* 排序参数 */
      isorter: {
        // column: 'createTime',
        // order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading: false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* 高级查询条件生效状态 */
      superQueryFlag: false,
      /* 高级查询条件 */
      superQueryParams: '',
      /** 高级查询拼接方式 */
      superQueryMatchType: 'and',
      /** primary key */
      rowKey: 'id',
    };
  },
  created() {
    this.initDictConfig();

    if (!this.disableMixinCreated) {
      console.log(' -- mixin created -- ');
      if (this.$route.query.name) {
        this.queryParam.userName = this.$route.query.name;
      }
      
    if (this.$route.query.wlUserId) this.queryParam.wlUserId = this.$route.query.wlUserId;
      this.loadData();
      //初始化字典配置 在自己页面定义
    }
  },
  computed: {
    //token header
    tokenHeader() {
      let head = { Authorization: getToken() };
      return head;
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.healthCode === 1) {
        return 'danger-row';
      } else if (row.healthCode === 2) {
        return 'warning-row';
      } else if (row.healthCode === 3) {
        return 'success-row';
      }
      return '';
    },
    getAvatar(url) {
      return getFileAccessHttpUrl(url);
    },
    // 查询数据
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams(); //查询条件
      this.loading = true;

      if (this.loadOtherData) {
        this.loadOtherData(params);
      }
      if (!this.loadWithGet) {
        postAction(this.url.list, params).then((res) => {
          if (res.msg) {
            this.$message.warning(res.msg);
            return;
          }
          // if (res.code==200) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          this.dataSource =
            res?.result?.records || res?.result || res.data.records;
          if (res.data.total) {
            this.ipagination.total = res.data.total;
          } else {
            this.ipagination.total = 0;
          }
          //update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          // }

          this.loading = false;
        });
      } else {
        getAction(this.url.list, params).then((res) => {
          if (res.msg) {
            this.$message.warning(res.msg);
            return;
          }
          // if (res.code==200) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          this.dataSource =
            res?.data ||
            res?.result?.records ||
            res?.result ||
            res.data.records;
            console.log(this.dataSource);
          if (res.data.total) {
            this.ipagination.total = res.data.total;
          } else {
            this.ipagination.total = 0;
          }
          //update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          // }

          this.loading = false;
        });
      }
    },
    // 初始化字典数据
    initDictConfig() {
      // console.log('--这是一个假的方法!');
    },
    //获取查询条件
    getQueryParams() {
      //获取查询条件
      var param = Object.assign(this.queryParam, this.isorter, this.filters);
      // param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      //TODO 字段权限控制
      // var str = 'id,'
      // this.columns.forEach(function(value) {
      //   str += ',' + value.dataIndex
      // })
      // return str
    },
    onSelectChange(selectionRows) {
      this.selectionRows = selectionRows;
      this.selectedRowKeys = selectionRows.map((item) => {
        return item[this.rowKey];
      });
      console.log(this.selectedRowKeys);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchQuery() {
      this.loadData(1);
    },
    superQuery() {
      this.$refs.superQueryModal.show();
    },
    searchReset() {
      this.queryParam = {};
      this.loadData(1);
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm('是否删除选中数据?', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            that.loading = true;
            postAction(that.url.deleteBatch, {}, { ids: ids }).then((res) => {
              if (res.code == 200) {
                //重新计算分页问题
                that.reCalculatePage(that.selectedRowKeys.length);
                that.$message.success('删除成功');
                that.loadData();
                that.onClearSelected();
              } else {
                that.$message.warning(res.msg);
              }
            });
          })
          .catch(() => {})
          .finally(() => {
            that.loading = false;
          });
      }
    },
    //删除
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      let param = {};
      param[this.deleteKey] = id;
      postAction(that.url.delete, param, param).then((res) => {
        if (res.code == 200) {
          //重新计算分页问题
          that.reCalculatePage(1);
          that.$message.success('删除成功');
          that.onClearSelected();
          that.loadData();
        } else {
          that.$message.warning(res.msg);
        }
      });
    },
    reCalculatePage(count) {
      //总数量-count
      let total = this.ipagination.total - count;
      //获取删除后的分页数
      let currentIndex = Math.ceil(total / this.ipagination.pageSize);
      //删除后的分页数<所在当前页
      if (currentIndex < this.ipagination.current) {
        this.ipagination.current = currentIndex;
      }
      console.log('currentIndex', currentIndex);
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleAdd: function () {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.loadData();
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    // 给popup查询使用(查询区域不支持回填多个字段，限制只返回一个字段)
    getPopupField(fields) {
      return fields.split(',')[0];
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
      //清空列表选中
      this.onClearSelected();
    },
    handleDetail: function (record, type) {
      this.$refs.modalForm.edit(record, type);
      this.$refs.modalForm.title = '详情';
      this.$refs.modalForm.disableSubmit = true;
    },
    /* 导出 */
    handleExportXls2() {
      // let paramsStr = encodeURI(JSON.stringify(this.getQueryParams()));
      // let url = `${window._CONFIG['domianURL']}/${this.url.exportXlsUrl}?paramsStr=${paramsStr}`;
      // window.location.href = url;
    },
    handleExportXls(fileName, url) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      let param = this.getQueryParams();
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }
      console.log('导出参数', param);
      downFile(url ? url : this.url.exportXlsUrl, param).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xlsx'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          ); //创建新的URL表示指定Blob对象
          let link = document.createElement('a'); //创建a标签
          link.style.display = 'none';//隐藏a标签
          link.href = url;  //直接href
          link.setAttribute('download', fileName + '.xlsx');
          document.body.appendChild(link); //将标签添加到body下
          link.click(); //触发下载链接
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    uploadFile(data, path = 'wali/', successc, failc) {
      return new Promise((resolve, reject) => {
        //获取policy
        const accessKeyId = 'LTAI5tNqmSgYG2oTeimKK5PC';
        const accessKeySecret = '8fT0oXd2SH2EyDsCpyKelemxsWLNtF';
        const aliyunServerURL =
          'https://waliminiapp.oss-cn-beijing.aliyuncs.com'; //OSS的访问域名
        const policyBase64 = getPolicyBase64();
        const signature = getSignature(policyBase64, accessKeySecret);

        let picName = randomString(10) + getSuffix(data.file.name);
        // let picName = data.file.name;
        let keyValue = path + picName;

        let formData = new FormData();
        formData.append('name', data.file.name); // 文件名称
        formData.append('key', keyValue); // 存储在oss的文件路径
        formData.append('OSSAccessKeyId', accessKeyId); // //accessKeyId
        formData.append('policy', policyBase64); // policy
        formData.append('Signature', signature); //签名
        formData.append('success_action_status', 200);
        formData.append('file', data.file, data.file.name); // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可

        uploadAction(aliyunServerURL, formData)
          .then((res) => {
            this.$message.success('上传成功');
            resolve(aliyunServerURL + '/' + keyValue);
          })
          .catch((err) => {
            this.$message.error('上传失败');
            reject();
          });
      });
    },
    /* 导入 */
    handleImportExcel(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          // this.$message.success(`${info.file.name} 文件上传成功`);
          if (info.file.response.code === 201) {
            let {
              message,
              result: { msg, fileUrl, fileName },
            } = info.file.response;
            let href = window._CONFIG['domianURL'] + fileUrl;
            this.$message({
              title: message,
              message: (
                <div>
                  <span>{msg}</span>
                  <br />
                  <span>
                    具体详情请{' '}
                    <a href={href} target="_blank" download={fileName}>
                      点击下载
                    </a>{' '}
                  </span>
                </div>
              ),
            });
          } else {
            this.$message.success(
              info.file.response.message || `${info.file.name} 文件上传成功`
            );
          }
          this.loadData();
        } else {
          this.$message.error(
            `${info.file.name} ${info.file.response.message}.`
          );
        }
      } else if (info.file.status === 'error') {
        if (info.file.response.status === 500) {
          let data = info.file.response;
          const token = getToken();
          if (token && data.message.includes('Token失效')) {
            MessageBox.alert('未授权，请重新登录', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: (action) => {
                store.dispatch('Logout').then(() => {
                  removeToken();
                  window.location.reload();
                });
              },
            });
          }
        } else {
          this.$message.error(`文件上传失败: ${info.file.msg} `);
        }
      }
    },
    /* 图片预览 */
    getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','));
      }
      return getFileAccessHttpUrl(text);
    },
    /* 文件下载 */
    // update--autor:lvdandan-----date:20200630------for：修改下载文件方法名uploadFile改为downloadFile------
    downloadFile(text) {
      if (!text) {
        this.$message.warning('未知的文件');
        return;
      }
      if (text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','));
      }
      let url = getFileAccessHttpUrl(text);
      window.open(url);
    },
  },
};
